export enum PlacementType {
  LEFT = 'Left',
  RIGHT = 'Right',
  LEFT_AND_RIGHT = 'LeftAndRight',
}